import { render, staticRenderFns } from "./WholesalerShareDialog.vue?vue&type=template&id=bd95bc5c&scoped=true"
import script from "./WholesalerShareDialog.vue?vue&type=script&lang=js"
export * from "./WholesalerShareDialog.vue?vue&type=script&lang=js"
import style0 from "./WholesalerShareDialog.vue?vue&type=style&index=0&id=bd95bc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd95bc5c",
  null
  
)

export default component.exports